var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.independiente,
              expression: "independiente"
            }
          ],
          staticClass: "layout__controls"
        },
        [
          _c("div", { staticClass: "form-inline" }, [
            _c(
              "button",
              {
                staticClass: "btn-success btn--bigger",
                attrs: { type: "button" },
                on: { click: _vm.guardar }
              },
              [
                _c("i", { staticClass: "fa fa-save" }),
                _vm._v(" "),
                _c("span", [_vm._v("Actualizar datos")])
              ]
            )
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field" }, [
          _c(
            "div",
            { staticClass: "file-upload-field" },
            [
              _c("label", [_vm._v("Foto")]),
              _vm._v(" "),
              _c("file-upload", {
                ref: "fileUpload",
                attrs: {
                  disabled: _vm.independiente,
                  defaultImage: _vm.srcImagen
                }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-info btn--text",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.descargarImagen(_vm.srcImagen)
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-download" })]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-danger btn--text",
                  attrs: { disabled: _vm.independiente, type: "button" },
                  on: { click: _vm.quitarFoto }
                },
                [_c("i", { staticClass: "fa fa-times" })]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.errores.imagen
            ? _c(
                "span",
                {
                  staticClass: "helper-text text-danger",
                  attrs: { slot: "helper" },
                  slot: "helper"
                },
                [_c("strong", [_vm._v(_vm._s(_vm.errores.imagen[0]))])]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field" }, [
          _c(
            "div",
            { staticClass: "file-upload-field" },
            [
              _c("label", [_vm._v("Logo")]),
              _vm._v(" "),
              _c("file-upload", {
                ref: "fileImagenReceta",
                attrs: { id: "receta", defaultImage: _vm.srcReceta }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-info btn--text",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.descargarImagen(_vm.srcReceta)
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-download" })]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-danger btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.quitarLogo }
                },
                [_c("i", { staticClass: "fa fa-times" })]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.errores.logo_receta
            ? _c(
                "span",
                {
                  staticClass: "helper-text text-danger",
                  attrs: { slot: "helper" },
                  slot: "helper"
                },
                [_c("strong", [_vm._v(_vm._s(_vm.errores.logo_receta[0]))])]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false"
            }
          ],
          staticClass: "col-xs-12 col-md-6"
        },
        [
          _c("div", { staticClass: "form-field" }, [
            _c(
              "div",
              { staticClass: "file-upload-field" },
              [
                _c("label", [_vm._v("Sello")]),
                _vm._v(" "),
                _c("file-upload", {
                  ref: "fileImagenSello",
                  attrs: { id: "sello", defaultImage: _vm.srcSello }
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn-info btn--text",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.descargarImagen(_vm.srcSello)
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-download" })]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn-danger btn--text",
                    attrs: { type: "button" },
                    on: { click: _vm.quitarSello }
                  },
                  [_c("i", { staticClass: "fa fa-times" })]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.errores.foto_sello
              ? _c(
                  "span",
                  {
                    staticClass: "helper-text text-danger",
                    attrs: { slot: "helper" },
                    slot: "helper"
                  },
                  [_c("strong", [_vm._v(_vm._s(_vm.errores.foto_sello[0]))])]
                )
              : _vm._e()
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false"
            }
          ],
          staticClass: "col-xs-12 col-md-6"
        },
        [
          _c("div", { staticClass: "form-field" }, [
            _c(
              "div",
              { staticClass: "file-upload-field" },
              [
                _c("label", [_vm._v("Firma")]),
                _vm._v(" "),
                _c("file-upload", {
                  ref: "fileImagenFirma",
                  attrs: { id: "firma", defaultImage: _vm.srcFirma }
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn-info btn--text",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.descargarImagen(_vm.srcFirma)
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-download" })]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn-danger btn--text",
                    attrs: { type: "button" },
                    on: { click: _vm.quitarFirma }
                  },
                  [_c("i", { staticClass: "fa fa-times" })]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.errores.foto_firma
              ? _c(
                  "span",
                  {
                    staticClass: "helper-text text-danger",
                    attrs: { slot: "helper" },
                    slot: "helper"
                  },
                  [_c("strong", [_vm._v(_vm._s(_vm.errores.foto_firma[0]))])]
                )
              : _vm._e()
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field" }, [
          _c(
            "div",
            { staticClass: "file-upload-field" },
            [
              _c("label", [_vm._v("Contrato")]),
              _vm._v(" "),
              _c("file-upload", {
                ref: "fileUploadContrato",
                attrs: {
                  id: "contrato",
                  disabled: _vm.independiente,
                  defaultImage: _vm.srcContrato
                }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-info btn--text",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.descargarImagen(_vm.srcContrato)
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-download" })]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-danger btn--text",
                  attrs: { disabled: _vm.independiente, type: "button" },
                  on: { click: _vm.quitarContrato }
                },
                [_c("i", { staticClass: "fa fa-times" })]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.errores.contrato
            ? _c(
                "span",
                {
                  staticClass: "helper-text text-danger",
                  attrs: { slot: "helper" },
                  slot: "helper"
                },
                [_c("strong", [_vm._v(_vm._s(_vm.errores.contrato[0]))])]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field" }, [
          _c(
            "div",
            { staticClass: "file-upload-field" },
            [
              _c("label", [_vm._v("Archivo Senescyt")]),
              _vm._v(" "),
              _c("file-upload", {
                ref: "fileUploadArchivoSenescyt",
                attrs: {
                  id: "archivo_senescyt",
                  disabled: _vm.independiente,
                  defaultImage: _vm.srcArchivoSenescyt
                }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-info btn--text",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.descargarImagen(_vm.srcArchivoSenescyt)
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-download" })]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-danger btn--text",
                  attrs: { disabled: _vm.independiente, type: "button" },
                  on: { click: _vm.quitarArchivoSenescyt }
                },
                [_c("i", { staticClass: "fa fa-times" })]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.errores.archivo_senescyt
            ? _c(
                "span",
                {
                  staticClass: "helper-text text-danger",
                  attrs: { slot: "helper" },
                  slot: "helper"
                },
                [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.errores.archivo_senescyt[0]))
                  ])
                ]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field" }, [
          _c(
            "div",
            { staticClass: "file-upload-field" },
            [
              _c("label", [_vm._v("Anexo 1")]),
              _vm._v(" "),
              _c("file-upload", {
                ref: "fileUploadAnexo1",
                attrs: {
                  id: "anexo_1",
                  disabled: _vm.independiente,
                  defaultImage: _vm.srcAnexo1
                }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-info btn--text",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.descargarImagen(_vm.srcAnexo1)
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-download" })]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-danger btn--text",
                  attrs: { disabled: _vm.independiente, type: "button" },
                  on: { click: _vm.quitarAnexo1 }
                },
                [_c("i", { staticClass: "fa fa-times" })]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.errores.anexo_1
            ? _c(
                "span",
                {
                  staticClass: "helper-text text-danger",
                  attrs: { slot: "helper" },
                  slot: "helper"
                },
                [_c("strong", [_vm._v(_vm._s(_vm.errores.anexo_1[0]))])]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field" }, [
          _c(
            "div",
            { staticClass: "file-upload-field" },
            [
              _c("label", [_vm._v("Anexo 2")]),
              _vm._v(" "),
              _c("file-upload", {
                ref: "fileUploadAnexo2",
                attrs: {
                  id: "anexo_2",
                  disabled: _vm.independiente,
                  defaultImage: _vm.srcAnexo2
                }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-info btn--text",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.descargarImagen(_vm.srcAnexo2)
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-download" })]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-danger btn--text",
                  attrs: { disabled: _vm.independiente, type: "button" },
                  on: { click: _vm.quitarAnexo2 }
                },
                [_c("i", { staticClass: "fa fa-times" })]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.errores.anexo_2
            ? _c(
                "span",
                {
                  staticClass: "helper-text text-danger",
                  attrs: { slot: "helper" },
                  slot: "helper"
                },
                [_c("strong", [_vm._v(_vm._s(_vm.errores.anexo_2[0]))])]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field" }, [
          _c(
            "div",
            { staticClass: "file-upload-field" },
            [
              _c("label", [_vm._v("Firma electrónica")]),
              _vm._v(" "),
              _c("file-upload", {
                ref: "fileUploadFirmaElectronica",
                attrs: {
                  id: "firmaElectronica",
                  defaultImage: _vm.srcFirmaElectronica,
                  soloFirmaElectronica: ""
                }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-info btn--text",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.descargarImagen(_vm.srcFirmaElectronica)
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-download" })]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-danger btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.quitarFirmaElectronica }
                },
                [_c("i", { staticClass: "fa fa-times" })]
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field" }, [
          _c(
            "div",
            { staticClass: "datepicker-field" },
            [
              _c("date-picker", {
                attrs: {
                  type: "date",
                  id: "fecha_caducidad_firma_electronica"
                },
                model: {
                  value: _vm.form.fecha_caducidad_firma_electronica,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "fecha_caducidad_firma_electronica", $$v)
                  },
                  expression: "form.fecha_caducidad_firma_electronica"
                }
              }),
              _vm._v(" "),
              _c("label", [_vm._v("Fecha caduc. (Firma Elect.)")]),
              _vm._v(" "),
              _vm.errores.fecha_caducidad_firma_electronica
                ? _c(
                    "span",
                    {
                      staticClass: "helper-text text-danger",
                      attrs: { slot: "helper" },
                      slot: "helper"
                    },
                    [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.errores.fecha_caducidad_firma_electronica[0]
                          )
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  type: !_vm.viendoPassword ? "password" : "text",
                  id: "password_firma_electronica",
                  placeholder: "Ingrese la contraseña..."
                },
                model: {
                  value: _vm.form.password_firma_electronica,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "password_firma_electronica", $$v)
                  },
                  expression: "form.password_firma_electronica"
                }
              },
              [
                _c("span", [_vm._v("Contraseña firma electr.")]),
                _vm._v(" "),
                _vm.errores.password_firma_electronica
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.errores.password_firma_electronica[0])
                        )
                      ]
                    )
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-info btn--text",
                attrs: { type: "button" },
                on: { click: _vm.verPassword }
              },
              [
                _c("i", {
                  staticClass: "fa",
                  class: {
                    "fa-eye": !_vm.viendoPassword,
                    "fa-eye-slash": _vm.viendoPassword
                  }
                })
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  type: "password",
                  id: "password_firma_electronica_confirmation",
                  placeholder: "Confirme la contraseña..."
                },
                model: {
                  value: _vm.form.password_firma_electronica_confirmation,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.form,
                      "password_firma_electronica_confirmation",
                      $$v
                    )
                  },
                  expression: "form.password_firma_electronica_confirmation"
                }
              },
              [_c("span", [_vm._v("Confirm. de cont. de firma elect.")])]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  readonly: _vm.independiente,
                  id: "nombre",
                  placeholder: "Nombres y apellidos"
                },
                model: {
                  value: _vm.form.nombre,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "nombre", $$v)
                  },
                  expression: "form.nombre"
                }
              },
              [
                _c("span", [_vm._v("Nombre")]),
                _vm._v(" "),
                _vm.errores.nombre
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.nombre[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  id: "codigo_senescyt",
                  placeholder: "Escriba el código..."
                },
                model: {
                  value: _vm.form.codigo_senescyt,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "codigo_senescyt", $$v)
                  },
                  expression: "form.codigo_senescyt"
                }
              },
              [
                _c("span", [_vm._v("Código Senescyt")]),
                _vm._v(" "),
                _vm.errores.codigo_senescyt
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.codigo_senescyt[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.form.estado !== "N",
              expression: "form.estado !== 'N'"
            }
          ],
          staticClass: "col-xs-12 col-md-6"
        },
        [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    vMoney: "",
                    format: _vm.money,
                    readonly: "",
                    id: "saldo_pagar",
                    placeholder: "$ #,###.##"
                  },
                  model: {
                    value: _vm.form.saldo_pagar,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "saldo_pagar", $$v)
                    },
                    expression: "form.saldo_pagar"
                  }
                },
                [
                  _c("span", [
                    _vm._v(
                      "Saldo por " +
                        _vm._s(_vm.independiente ? "cobrar" : "pagar")
                    )
                  ])
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  type: "password",
                  id: "clave_acceso",
                  placeholder: "Clave de acceso"
                },
                model: {
                  value: _vm.form.clave_acceso,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "clave_acceso", $$v)
                  },
                  expression: "form.clave_acceso"
                }
              },
              [
                _c("span", [_vm._v("Contraseña")]),
                _vm._v(" "),
                _vm.errores.clave_acceso
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.clave_acceso[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  type: "password",
                  id: "clave_acceso_confirmation",
                  placeholder: "Confirmar clave..."
                },
                model: {
                  value: _vm.form.clave_acceso_confirmation,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "clave_acceso_confirmation", $$v)
                  },
                  expression: "form.clave_acceso_confirmation"
                }
              },
              [
                _c("span", [_vm._v("Confirmación de contraseña")]),
                _vm._v(" "),
                _vm.errores.clave_acceso_confirmation
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.errores.clave_acceso_confirmation[0])
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field" }, [
          _c(
            "div",
            { staticClass: "datepicker-field" },
            [
              _c("date-picker", {
                attrs: {
                  disabled: _vm.independiente,
                  type: "date",
                  id: "fecha_nacimiento"
                },
                model: {
                  value: _vm.form.fecha_nacimiento,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "fecha_nacimiento", $$v)
                  },
                  expression: "form.fecha_nacimiento"
                }
              }),
              _vm._v(" "),
              _c("label", [_vm._v("Fecha de nacimiento")]),
              _vm._v(" "),
              _vm.errores.fecha_nacimiento
                ? _c(
                    "span",
                    {
                      staticClass: "helper-text text-danger",
                      attrs: { slot: "helper" },
                      slot: "helper"
                    },
                    [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.errores.fecha_nacimiento[0]))
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  readonly: "",
                  id: "edad",
                  placeholder: "Edad",
                  value: _vm.edad
                }
              },
              [_c("span", [_vm._v("Edad")])]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field select" }, [
          _c("div", { staticClass: "select-field" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.tipo_documento,
                    expression: "form.tipo_documento"
                  }
                ],
                attrs: { name: "tipo_documento", id: "tipo_documento" },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.form,
                      "tipo_documento",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  }
                }
              },
              [
                _c("option", { attrs: { value: "C" } }, [_vm._v("Cédula")]),
                _vm._v(" "),
                _c("option", { attrs: { value: "R" } }, [_vm._v("RUC")]),
                _vm._v(" "),
                _c("option", { attrs: { value: "P" } }, [_vm._v("Pasaporte")])
              ]
            ),
            _vm._v(" "),
            _c("label", { attrs: { for: "tipo_documento" } }, [
              _vm._v("Tipo de documento")
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                directives: [
                  {
                    name: "mask",
                    rawName: "v-mask",
                    value: "#############",
                    expression: "'#############'"
                  }
                ],
                attrs: {
                  disabled: _vm.independiente,
                  id: "cedula",
                  placeholder: "Número de identificación"
                },
                model: {
                  value: _vm.form.cedula,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "cedula", $$v)
                  },
                  expression: "form.cedula"
                }
              },
              [
                _c("span", [_vm._v("Céd/RUC/Pasaporte")]),
                _vm._v(" "),
                _vm.errores.cedula
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.cedula[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field select2" }, [
          _c(
            "div",
            { staticClass: "select2-field" },
            [
              _c("v-select", {
                attrs: {
                  id: "provincia",
                  placeholder: "Seleccione...",
                  options: _vm.provincias,
                  label: "descripcion"
                },
                on: { input: _vm.inputProvincia },
                model: {
                  value: _vm.selectedProvincia,
                  callback: function($$v) {
                    _vm.selectedProvincia = $$v
                  },
                  expression: "selectedProvincia"
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "provincia" } }, [
                _vm._v("Provincia")
              ])
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field select2" }, [
          _c(
            "div",
            { staticClass: "select2-field" },
            [
              _c("v-select", {
                attrs: {
                  id: "ciudad",
                  placeholder: "Seleccione...",
                  options: _vm.ciudades,
                  label: "descripcion"
                },
                on: { input: _vm.inputCiudad },
                model: {
                  value: _vm.selectedCiudad,
                  callback: function($$v) {
                    _vm.selectedCiudad = $$v
                  },
                  expression: "selectedCiudad"
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "ciudad" } }, [_vm._v("Ciudad")]),
              _vm._v(" "),
              _vm.errores.ciudad_id
                ? _c(
                    "span",
                    {
                      staticClass: "helper-text text-danger",
                      attrs: { slot: "helper" },
                      slot: "helper"
                    },
                    [_c("strong", [_vm._v(_vm._s(_vm.errores.ciudad_id[0]))])]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  id: "direccion",
                  placeholder: "Escriba una dirección..."
                },
                model: {
                  value: _vm.form.direccion,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "direccion", $$v)
                  },
                  expression: "form.direccion"
                }
              },
              [
                _c("span", [_vm._v("Dirección")]),
                _vm._v(" "),
                _vm.errores.direccion
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.direccion[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  id: "telefonos",
                  placeholder: "Escriba uno o varios teléfonos..."
                },
                model: {
                  value: _vm.form.telefonos,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "telefonos", $$v)
                  },
                  expression: "form.telefonos"
                }
              },
              [
                _c("span", [_vm._v("Teléfonos")]),
                _vm._v(" "),
                _vm.errores.telefonos
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.telefonos[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  readonly: _vm.independiente,
                  id: "correo",
                  placeholder: "Escriba una dirección de correo electrónico..."
                },
                model: {
                  value: _vm.form.correo,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "correo", $$v)
                  },
                  expression: "form.correo"
                }
              },
              [
                _c("span", [_vm._v("Correo electrónico")]),
                _vm._v(" "),
                _vm.errores.correo
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.correo[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("label", { attrs: { for: "masculino" } }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.sexo,
                expression: "form.sexo"
              }
            ],
            attrs: {
              disabled: _vm.independiente,
              type: "radio",
              name: "sexo",
              id: "masculino",
              value: "M"
            },
            domProps: { checked: _vm._q(_vm.form.sexo, "M") },
            on: {
              change: function($event) {
                return _vm.$set(_vm.form, "sexo", "M")
              }
            }
          }),
          _vm._v(" "),
          _c("span", [_vm._v("Masculino")])
        ]),
        _vm._v(" "),
        _c("label", { attrs: { for: "femenino" } }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.sexo,
                expression: "form.sexo"
              }
            ],
            attrs: {
              disabled: _vm.independiente,
              type: "radio",
              name: "sexo",
              id: "femenino",
              value: "F"
            },
            domProps: { checked: _vm._q(_vm.form.sexo, "F") },
            on: {
              change: function($event) {
                return _vm.$set(_vm.form, "sexo", "F")
              }
            }
          }),
          _vm._v(" "),
          _c("span", [_vm._v("Femenino")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          {
            staticClass: "form-field select2",
            class: {
              "select2--disabled": _vm.independiente
            }
          },
          [
            _c(
              "div",
              { staticClass: "select2-field" },
              [
                _c("v-select", {
                  attrs: {
                    placeholder: "Seleccione...",
                    id: "especialidades",
                    options: _vm.especialidades,
                    label: "descripcion",
                    multiple: ""
                  },
                  on: { input: _vm.inputEspecialidades },
                  model: {
                    value: _vm.selectedEspecialidades,
                    callback: function($$v) {
                      _vm.selectedEspecialidades = $$v
                    },
                    expression: "selectedEspecialidades"
                  }
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "especialidades" } }, [
                  _vm._v("Especialidades")
                ]),
                _vm._v(" "),
                _vm.errores.especialidades
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.especialidades[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field" }, [
          _c("p", [
            _c("label", { attrs: { for: "es_odontologo" } }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.es_odontologo,
                    expression: "form.es_odontologo"
                  }
                ],
                attrs: {
                  type: "checkbox",
                  name: "es_odontologo",
                  id: "es_odontologo"
                },
                domProps: {
                  checked: Array.isArray(_vm.form.es_odontologo)
                    ? _vm._i(_vm.form.es_odontologo, null) > -1
                    : _vm.form.es_odontologo
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.form.es_odontologo,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(_vm.form, "es_odontologo", $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.form,
                            "es_odontologo",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.form, "es_odontologo", $$c)
                    }
                  }
                }
              }),
              _c("span", [_vm._v("Es odontólogo")])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field" }, [
          _c("p", [
            _c("label", { attrs: { for: "es_otras_especialidades" } }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.es_otras_especialidades,
                    expression: "form.es_otras_especialidades"
                  }
                ],
                attrs: {
                  type: "checkbox",
                  name: "es_otras_especialidades",
                  id: "es_otras_especialidades"
                },
                domProps: {
                  checked: Array.isArray(_vm.form.es_otras_especialidades)
                    ? _vm._i(_vm.form.es_otras_especialidades, null) > -1
                    : _vm.form.es_otras_especialidades
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.form.es_otras_especialidades,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.form,
                            "es_otras_especialidades",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.form,
                            "es_otras_especialidades",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.form, "es_otras_especialidades", $$c)
                    }
                  }
                }
              }),
              _c("span", [_vm._v("Tiene otras especialidades")])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field select" }, [
          _c("div", { staticClass: "select-field" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.tipo_cuenta,
                    expression: "form.tipo_cuenta"
                  }
                ],
                attrs: { name: "tipo_cuenta", id: "tipo_cuenta" },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.form,
                      "tipo_cuenta",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  }
                }
              },
              [
                _c("option", { attrs: { value: "A" } }, [_vm._v("Ahorros")]),
                _vm._v(" "),
                _c("option", { attrs: { value: "C" } }, [_vm._v("Corriente")])
              ]
            ),
            _vm._v(" "),
            _c("label", { attrs: { for: "tipo_cuenta" } }, [
              _vm._v("Tipo de cuenta")
            ]),
            _vm._v(" "),
            _vm.errores.tipo_cuenta
              ? _c(
                  "span",
                  {
                    staticClass: "helper-text text-danger",
                    attrs: { slot: "helper" },
                    slot: "helper"
                  },
                  [_c("strong", [_vm._v(_vm._s(_vm.errores.tipo_cuenta[0]))])]
                )
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                directives: [
                  {
                    name: "mask",
                    rawName: "v-mask",
                    value: "####################",
                    expression: "'####################'"
                  }
                ],
                attrs: { id: "numero_cuenta", placeholder: "Especifique..." },
                model: {
                  value: _vm.form.numero_cuenta,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "numero_cuenta", $$v)
                  },
                  expression: "form.numero_cuenta"
                }
              },
              [
                _vm._v("\n          Número de cuenta\n          "),
                _vm.errores.numero_cuenta
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.numero_cuenta[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { id: "nombre_cuenta", placeholder: "Especifique..." },
                model: {
                  value: _vm.form.nombre_cuenta,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "nombre_cuenta", $$v)
                  },
                  expression: "form.nombre_cuenta"
                }
              },
              [
                _vm._v("\n          Nombre de propietario\n          "),
                _vm.errores.nombre_cuenta
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.nombre_cuenta[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field select" }, [
          _c("div", { staticClass: "select-field" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.tipo_identificacion_cuenta,
                    expression: "form.tipo_identificacion_cuenta"
                  }
                ],
                attrs: {
                  name: "tipo_identificacion_cuenta",
                  id: "tipo_identificacion_cuenta"
                },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.form,
                      "tipo_identificacion_cuenta",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  }
                }
              },
              [
                _c("option", { attrs: { value: "C" } }, [_vm._v("Cédula")]),
                _vm._v(" "),
                _c("option", { attrs: { value: "R" } }, [_vm._v("RUC")]),
                _vm._v(" "),
                _c("option", { attrs: { value: "P" } }, [_vm._v("Pasaporte")])
              ]
            ),
            _vm._v(" "),
            _c("label", { attrs: { for: "tipo_identificacion_cuenta" } }, [
              _vm._v("Tipo de documento de propietario")
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                directives: [
                  {
                    name: "mask",
                    rawName: "v-mask",
                    value: "####################",
                    expression: "'####################'"
                  }
                ],
                attrs: {
                  id: "identificacion_cuenta",
                  placeholder: "Especifique..."
                },
                model: {
                  value: _vm.form.identificacion_cuenta,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "identificacion_cuenta", $$v)
                  },
                  expression: "form.identificacion_cuenta"
                }
              },
              [
                _vm._v(
                  "\n          Identificación del propietario\n          "
                ),
                _vm.errores.identificacion_cuenta
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.identificacion_cuenta[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { id: "banco", placeholder: "Especifique..." },
                model: {
                  value: _vm.form.banco,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "banco", $$v)
                  },
                  expression: "form.banco"
                }
              },
              [
                _vm._v("\n          Nombre del banco\n          "),
                _vm.errores.banco
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.banco[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "textarea-field",
              {
                attrs: {
                  max: 500,
                  id: "comentario",
                  placeholder: "Escriba un comentario..."
                },
                model: {
                  value: _vm.form.comentario,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "comentario", $$v)
                  },
                  expression: "form.comentario"
                }
              },
              [
                _c("span", [_vm._v("Comentario")]),
                _vm._v(" "),
                _vm.errores.comentario
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.comentario[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  vMoney: "",
                  format: _vm.decimal5,
                  id: "latitud",
                  placeholder: "Escriba la latitud..."
                },
                model: {
                  value: _vm.form.latitud,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "latitud", $$v)
                  },
                  expression: "form.latitud"
                }
              },
              [
                _c("span", [_vm._v("Latitud")]),
                _vm._v(" "),
                _vm.errores.latitud
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.latitud[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  vMoney: "",
                  format: _vm.decimal5,
                  id: "longitud",
                  placeholder: "Escriba la longitud..."
                },
                model: {
                  value: _vm.form.longitud,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "longitud", $$v)
                  },
                  expression: "form.longitud"
                }
              },
              [
                _c("span", [_vm._v("Longitud")]),
                _vm._v(" "),
                _vm.errores.longitud
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.longitud[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-inline" }, [
          _c(
            "button",
            {
              staticClass: "btn-primary btn--text",
              attrs: { type: "button" },
              on: { click: _vm.validarCoordenadas }
            },
            [
              _c("i", { staticClass: "fa fa-check" }),
              _vm._v(" "),
              _c("span", [_vm._v("Validar coordenadas")])
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn-danger btn--text",
              attrs: { type: "button" },
              on: { click: _vm.quitarCoordenadas }
            },
            [
              _c("i", { staticClass: "fa fa-times" }),
              _vm._v(" "),
              _c("span", [_vm._v("Quitar coordenadas")])
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-xs-12" },
        [
          _c(
            "l-map",
            {
              ref: "map",
              staticStyle: { width: "100%", height: "250px" },
              attrs: { zoom: _vm.zoom, center: _vm.center }
            },
            [
              _c("l-tile-layer", { attrs: { url: _vm.urlLayer } }),
              _vm._v(" "),
              _c("l-marker", {
                attrs: { draggable: "", "lat-lng": _vm.markerPosition },
                on: { "update:latLng": _vm.actualizarCoordenadas }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-xs-12 col-md-6" },
        [
          _c("multiple-fotos", {
            model: {
              value: _vm.form.fotos,
              callback: function($$v) {
                _vm.$set(_vm.form, "fotos", $$v)
              },
              expression: "form.fotos"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "textarea-field",
              {
                attrs: {
                  max: 800,
                  rows: "7",
                  id: "biografia",
                  placeholder: "Escriba una corta biografía..."
                },
                model: {
                  value: _vm.form.biografia,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "biografia", $$v)
                  },
                  expression: "form.biografia"
                }
              },
              [
                _c("span", [_vm._v("Biografía")]),
                _vm._v(" "),
                _vm.errores.biografia
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.biografia[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.independiente,
            expression: "!independiente"
          }
        ],
        staticClass: "modal-buttons"
      },
      [
        _c(
          "button",
          {
            staticClass: "btn-success",
            attrs: { type: "button" },
            on: { click: _vm.guardar }
          },
          [
            _c("i", { staticClass: "fa fa-save" }),
            _vm._v(" "),
            _c("span", [_vm._v("Guardar")])
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn-danger btn--text",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.$emit("cancelar")
              }
            }
          },
          [
            _c("i", { staticClass: "fa fa-ban" }),
            _vm._v(" "),
            _c("span", [_vm._v("Cancelar")])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Médico")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57fc6b9a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57fc6b9a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/doctores/Doctor.vue
// module id = 567
// module chunks = 0